import getters from "@/store/modules/projects/getters";
export default {
    namespaced: true,
    state() {
        return {
            projects: [
                {
                    id: 'p01',
                    title: 'Sudoku',
                    img: 'Sudoku.png',
                    link: 'https://github.com/Im-Mad/SudokuGame',
                    description: 'One of the most popular games "Sudoku" created with Java and JavaFX.',
                    tags: ['JavaFx', 'Java']
                },
                {
                    id: 'p02',
                    title: 'Green Tours',
                    img: 'natours.jpeg',
                    link: 'https://github.com/Im-Mad/Green-Tours',
                    description: 'Green Tours is a plateform to connect tours lovers to an agency that organize camps, excursions and trips.',
                    tags: ['Pug', 'NodeJS', 'ExpressJS', 'Mongoose','Stripe']
                },
                {
                    id: 'p03',
                    title: 'Ensa Events',
                    img: 'ensa_events.png',
                    link: 'https://github.com/Im-Mad/Ensa_Events',
                    description: 'EnsaEvent is a self-service platform aimed at better connecting our school\'s clubs with their members and all the other students that are intrested in the events organized by these clubs. It allows anyone to share, find and attend events that fuel their passions and enrich their academic lives. From confrences, formations, workshops, to gaming competitions, coding contests and hackathons.\n' +
                        '\n',
                    tags: ['Spring MVC', 'Spring Security', 'Hibernate', 'JPA','Bootstrap','Javamail','Swipper'],
                },
            ]
        }
    },
    getters,
}